(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const productForms = document.querySelectorAll('product-form');

    productForms.forEach(productForm => {
      let bundleVariantInput = productForm.querySelector('[data-bundle-variant-input]');

      if (!bundleVariantInput) {
        const form = productForm.querySelector('form');
        const formId = form ? form.getAttribute('id') : null;

        if (formId) {
          bundleVariantInput = document.querySelector(`[data-bundle-variant-input][form="${formId}"]`);
        }
      }

      if (!bundleVariantInput) {
        return;
      }

      setupBundleForm(productForm, bundleVariantInput);
    });
  }

  function setupBundleForm(productForm, bundleVariantInput) {
    const form = productForm.querySelector('form');
    const formId = form ? form.getAttribute('id') : null;

    let bundleVariantSelects = productForm.querySelector('variant-selects[data-bundle]');
    if (!bundleVariantSelects && formId) {
      const allBundleSelects = document.querySelectorAll('variant-selects[data-bundle]');
      for (const selects of allBundleSelects) {
        const selectInput = selects.querySelector(`[form="${formId}"]`);
        if (selectInput) {
          bundleVariantSelects = selects;
          break;
        }
      }
    }

    const submitButton = productForm.querySelector('[type="submit"]');

    if (!form) {
      return;
    }

    let bundleVariantsData = null;
    let bundleProductData = null;

    let variantsJson = productForm.querySelector('[data-bundle-variants]');
    if (!variantsJson && bundleVariantSelects) {
      variantsJson = bundleVariantSelects.querySelector('[data-bundle-variants]');
    }
    if (variantsJson) {
      try {
        bundleVariantsData = JSON.parse(variantsJson.textContent);
      } catch (e) {}
    }

    let productJson = productForm.querySelector('[data-bundle-product]');
    if (!productJson && bundleVariantSelects) {
      productJson = bundleVariantSelects.querySelector('[data-bundle-product]');
    }
    if (productJson) {
      try {
        bundleProductData = JSON.parse(productJson.textContent);
      } catch (e) {}
    }

    let singleVariantInput = productForm.querySelector('[data-bundle-single-variant] input[data-bundle-variant-id]');
    if (!singleVariantInput && formId) {
      const singleVariantContainer = document.querySelector('[data-bundle-single-variant]');
      if (singleVariantContainer) {
        singleVariantInput = singleVariantContainer.querySelector('input[data-bundle-variant-id]');
      }
    }
    if (singleVariantInput && bundleVariantInput) {
      bundleVariantInput.value = singleVariantInput.value;
    }

    if (bundleVariantSelects) {
      bundleVariantSelects.addEventListener('change', function(e) {
        const selectedOptions = getSelectedBundleOptions(bundleVariantSelects);
        const matchedVariant = findMatchingVariant(selectedOptions, bundleVariantsData);

        if (matchedVariant) {
          bundleVariantInput.value = matchedVariant.id;
          updateBundlePrice(productForm, matchedVariant);
        } else {
          bundleVariantInput.value = '';
          updateBundlePrice(productForm, null);
        }
      });

      const initialOptions = getSelectedBundleOptions(bundleVariantSelects);
      if (initialOptions.some(opt => opt !== '')) {
        const matchedVariant = findMatchingVariant(initialOptions, bundleVariantsData);
        if (matchedVariant) {
          bundleVariantInput.value = matchedVariant.id;
          updateBundlePrice(productForm, matchedVariant);
        }
      }
    }

    if (singleVariantInput && bundleVariantsData && bundleVariantsData.length === 1) {
      updateBundlePrice(productForm, bundleVariantsData[0]);
    }

    function recalculateBundlePrice() {
      const currentBundleVariantId = bundleVariantInput.value;
      if (currentBundleVariantId && bundleVariantsData) {
        const currentBundleVariant = bundleVariantsData.find(v => v.id == currentBundleVariantId);
        if (currentBundleVariant) {
          updateBundlePrice(productForm, currentBundleVariant);
        }
      }
    }

    const mainVariantIdInput = form.querySelector('input[name="id"]');
    if (mainVariantIdInput) {
      mainVariantIdInput.addEventListener('change', function(e) {
        setTimeout(recalculateBundlePrice, 200);
      });

      const variantObserver = new MutationObserver(function(mutations) {
        setTimeout(recalculateBundlePrice, 200);
      });

      variantObserver.observe(mainVariantIdInput, {
        attributes: true,
        attributeFilter: ['value']
      });
    }

    form.addEventListener('submit', function(e) {
      const hasBundleProduct = bundleProductData || singleVariantInput;

      if (!hasBundleProduct) {
        return;
      }

      if (!bundleVariantInput.value || bundleVariantInput.value === '') {
        e.preventDefault();
        e.stopPropagation();

        const missingOption = getMissingBundleOption(productForm, bundleVariantSelects);

        let errorMessage;
        if (missingOption) {
          errorMessage = `Please choose ${missingOption}`;
        } else {
          errorMessage = `Please select bundle product options`;
        }

        if (productForm.handleErrorMessage) {
          productForm.handleErrorMessage(errorMessage);
        } else {
          alert(errorMessage);
        }

        return false;
      }

      if (bundleVariantInput.value && bundleVariantInput.value !== '') {
        e.preventDefault();
        e.stopPropagation();

        if (submitButton.getAttribute('aria-disabled') === 'true') return false;

        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');

        addBundleToCart(form, bundleVariantInput.value, bundleProductData, productForm, submitButton);

        return false;
      }
    }, true);
  }

  function getSelectedBundleOptions(bundleVariantSelects) {
    if (!bundleVariantSelects) return [];

    const options = [];

    const selects = bundleVariantSelects.querySelectorAll('select[data-option-name]');
    selects.forEach(select => {
      options.push(select.value || '');
    });

    const fieldsets = bundleVariantSelects.querySelectorAll('fieldset');
    fieldsets.forEach(fieldset => {
      const checkedInput = fieldset.querySelector('input:checked');
      if (checkedInput) {
        options.push(checkedInput.value);
      } else if (selects.length === 0) {
        options.push('');
      }
    });

    return options;
  }

  function findMatchingVariant(selectedOptions, bundleVariantsData) {
    if (!bundleVariantsData || selectedOptions.length === 0) return null;

    if (bundleVariantsData.length === 1) {
      return bundleVariantsData[0];
    }

    const allOptionsSelected = selectedOptions.every(opt => opt !== '');
    if (!allOptionsSelected) {
      return null;
    }

    const matchedVariant = bundleVariantsData.find(variant => {
      const matches = selectedOptions.every((option, index) => {
        return variant.options[index] === option;
      });
      return matches;
    });

    return matchedVariant || null;
  }

  function updateBundlePrice(productForm, bundleVariant) {
    let priceElement = null;

    const productInfo = productForm.closest('product-info') || document.querySelector('product-info');

    if (productInfo) {
      priceElement = productInfo.querySelector('.price');
    }

    if (!priceElement) {
      priceElement = productForm.querySelector('.price');
    }

    if (!priceElement) {
      priceElement = document.querySelector('.product .price');
    }

    if (!priceElement) {
      return;
    }

    let mainVariantJson = productForm.querySelector('[data-selected-variant]');
    if (!mainVariantJson) {
      mainVariantJson = document.querySelector('[data-selected-variant]');
    }

    let mainVariant = null;
    if (mainVariantJson) {
      try {
        mainVariant = JSON.parse(mainVariantJson.textContent);
      } catch (e) {
        return;
      }
    }

    if (!mainVariant) {
      return;
    }

    let displayPrice = mainVariant.price;
    let displayComparePrice = mainVariant.compare_at_price;

    if (bundleVariant) {
      displayPrice = mainVariant.price + bundleVariant.price;
      if (mainVariant.compare_at_price && bundleVariant.compare_at_price) {
        displayComparePrice = mainVariant.compare_at_price + bundleVariant.compare_at_price;
      } else if (bundleVariant.compare_at_price) {
        displayComparePrice = mainVariant.price + bundleVariant.compare_at_price;
      } else if (mainVariant.compare_at_price) {
        displayComparePrice = mainVariant.compare_at_price + bundleVariant.price;
      }
    }

    const priceRegularContainer = priceElement.querySelector('.price__regular');
    const priceSaleContainer = priceElement.querySelector('.price__sale');

    if (displayComparePrice && displayComparePrice > displayPrice) {
      const salePriceMoney = priceSaleContainer?.querySelector('.price-item--sale price-money');
      if (salePriceMoney) {
        salePriceMoney.innerHTML = formatMoneyForCurrencyConverter(displayPrice);
      }

      const comparePriceMoney = priceSaleContainer?.querySelector('.price__compare price-money');
      if (comparePriceMoney) {
        comparePriceMoney.innerHTML = formatMoneyForCurrencyConverter(displayComparePrice);
      }

      if (priceSaleContainer) priceSaleContainer.style.display = '';
      if (priceRegularContainer) priceRegularContainer.style.display = 'none';
      priceElement.classList.add('price--on-sale');
    } else {
      const regularPriceMoney = priceRegularContainer?.querySelector('.price-item--regular price-money');
      if (regularPriceMoney) {
        regularPriceMoney.innerHTML = formatMoneyForCurrencyConverter(displayPrice);
      }

      if (priceRegularContainer) priceRegularContainer.style.display = '';
      if (priceSaleContainer) priceSaleContainer.style.display = 'none';
      priceElement.classList.remove('price--on-sale');
    }

    triggerCurrencyConverter(priceElement);
  }

  function triggerCurrencyConverter(priceElement) {
    if (typeof Currency !== 'undefined' && Currency.convertAll) {
      Currency.convertAll(window.shop_currency, Currency.currentCurrency);
    } else if (typeof window.ConversionBear !== 'undefined') {
      window.ConversionBear.update();
    } else {
      const event = new CustomEvent('currency:update');
      document.dispatchEvent(event);
    }
  }

  function formatMoneyForCurrencyConverter(cents) {
    if (typeof theme !== 'undefined' && theme.shopSettings && theme.shopSettings.moneyFormat) {
      let format = theme.shopSettings.moneyFormat;
      const dollars = (cents / 100).toFixed(2);
      const dollarsNoDecimals = Math.floor(cents / 100).toString();
      const dollarsWithComma = dollars.replace('.', ',');

      format = format.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, dollarsWithComma);
      format = format.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dollarsNoDecimals);
      format = format.replace(/\{\{\s*amount\s*\}\}/g, dollars);

      return `<bdi><span class="money conversion-bear-money">${format}</span></bdi>`;
    }
    return `<bdi><span class="money conversion-bear-money">$${(cents / 100).toFixed(2)}</span></bdi>`;
  }

  function getMissingBundleOption(productForm, bundleVariantSelects) {
    if (!bundleVariantSelects) {
      const singleVariantLabel = productForm.querySelector('[data-bundle-single-variant] [data-option-name]');
      if (singleVariantLabel) {
        return singleVariantLabel.dataset.optionName;
      }
      return null;
    }

    const selects = bundleVariantSelects.querySelectorAll('select[data-option-name]');
    for (const select of selects) {
      if (!select.value || select.value === '') {
        return select.dataset.optionName;
      }
    }

    const fieldsets = bundleVariantSelects.querySelectorAll('fieldset');
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('[data-option-name]');
      const checkedInput = fieldset.querySelector('input:checked');
      if (!checkedInput && legend) {
        return legend.dataset.optionName;
      }
    }

    return null;
  }

  async function addBundleToCart(form, bundleVariantId, bundleProductData, productForm, submitButton) {
    const formData = new FormData(form);
    const quantity = parseInt(formData.get('quantity') || '1');

    const items = [];

    const mainItem = {
      id: parseInt(formData.get('id')),
      quantity: quantity,
      properties: {}
    };

    for (let [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && !key.includes('_bundle_product')) {
        const propName = key.replace('properties[', '').replace(']', '');
        mainItem.properties[propName] = value;
      }
    }

    items.push(mainItem);

    if (bundleVariantId && bundleProductData) {
      const mainProductTitle = document.querySelector('.product__title')?.textContent.trim() || 'Main Product';

      items.push({
        id: parseInt(bundleVariantId),
        quantity: quantity,
        properties: {
          'Bundled': 'yes',
          'Parent': mainProductTitle
        }
      });
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    const body = {
      items: items
    };

    const cart = document.querySelector('mini-cart');
    if (cart) {
      body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      body.sections_url = window.location.pathname;
    }

    config.body = JSON.stringify(body);

    try {
      const response = await fetch(`${theme.routes.cart_add_url}`, config);
      const data = await response.json();

      if (data.status || data.errors) {
        handleCartError(data, formData, productForm);
      } else {
        handleCartSuccess(data, cart);
      }
    } catch (error) {
      handleCartError({ description: 'An error occurred. Please try again.' }, formData, productForm);
    } finally {
      submitButton.classList.remove('loading');
      if (cart && cart.classList.contains('is-empty')) {
        cart.classList.remove('is-empty');
      }
      submitButton.removeAttribute('aria-disabled');
    }
  }

  function handleCartError(response, formData, productForm) {
    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'bundle-product-form',
        productVariantId: formData.get('id'),
        errors: response.errors || response.description,
        message: response.message,
      });
    }

    if (productForm.handleErrorMessage) {
      productForm.handleErrorMessage(response.description);
    } else {
      alert(response.description || 'Error adding to cart');
    }
  }

  function handleCartSuccess(response, cart) {
    if (!cart) {
      window.location = theme.routes.cart_url;
      return;
    }

    if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-product-form',
        cartData: response,
      });
    }

    cart.renderContents(response);
  }
})();
